export default __webpack_public_path__ + "static/hero-b69b4f29b4d29d7bb04f3bf647aa5c62.webp";